import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton, CFormLabel, CFormSelect, CMultiSelect } from '@coreui/react-pro'
import { selectDemographics } from '../../../../../redux/demographics/demographicsSlice'
import {
  formatForMultiSelect,
  formatForSingleSelect,
} from '../../../../../components/common/shared/sharedPatientLogic'
import { savePatientDetails } from '../../../../../redux/sidePanel/sidePanelThunk'

export default function PatientDemoEditCard({ setEditPatientDemo }) {
  const dispatch = useDispatch()
  const demographicCodes = useSelector(selectDemographics)

  const race = useSelector((state) => state.sidePanel.panelEncounter?.race)
  const ethnicity = useSelector((state) => state.sidePanel.panelEncounter?.ethnicity)
  const sexOrient = useSelector((state) => state.sidePanel.panelEncounter?.sexualOrientation)
  const genderIdent = useSelector((state) => state.sidePanel.panelEncounter?.genderIdentity)
  const prefLang = useSelector((state) => state.sidePanel.panelEncounter?.preferredLanguage)

  const [newRace, setNewRace] = useState(race)
  const [newEthnicity, setNewEthnicity] = useState(ethnicity)
  const [newSexOrient, setNewSexOrient] = useState(sexOrient)
  const [newGenderIdent, setNewGenderIdent] = useState(genderIdent)
  const [newPrefLang, setNewPrefLang] = useState(prefLang)

  return (
    <div id={'PatientDemoEditCard'}>
      <div>
        <CFormLabel className="label">Race</CFormLabel>
        <div className="select-box-holder">
          {demographicCodes?.raceCodes?.length > 0 && (
            // coreUI component is buggy and unable to refresh
            // so don't show it until demographics load in
            <CMultiSelect
              className={'select-box full-width fit-height default-select-dropdown'}
              placeholder={''}
              cleaner={false}
              options={formatForMultiSelect(demographicCodes.raceCodes, newRace)}
              selectionType={'text'}
              onChange={(newRaceValues) =>
                setNewRace(newRaceValues.map((raceObject) => raceObject.value))
              }
              selectAll={false}
              optionsStyle={'checkbox'}
            />
          )}
        </div>
      </div>
      <div>
        <CFormLabel className="label">Ethnicity</CFormLabel>
        <div className="select-box-holder">
          <CFormSelect
            className={'select-box full-width'}
            options={formatForSingleSelect(demographicCodes.ethnicityCodes)}
            onChange={({ target: { value: newE } }) => setNewEthnicity(newE)}
            value={newEthnicity}
          />
        </div>
      </div>
      <div>
        <CFormLabel className="label">Sexual Orientation</CFormLabel>
        <div className="select-box-holder">
          <CFormSelect
            className={'select-box full-width'}
            options={formatForSingleSelect(demographicCodes.sexualOrientationCodes)}
            onChange={({ target: { value: newSE } }) => setNewSexOrient(newSE)}
            value={newSexOrient}
          />
        </div>
      </div>
      <div>
        <CFormLabel className="label">Gender Identity</CFormLabel>
        <div className="select-box-holder">
          <CFormSelect
            className={'select-box full-width fit-height'}
            options={formatForSingleSelect(demographicCodes.genderIdentityCodes)}
            onChange={({ target: { value: newGI } }) => setNewGenderIdent(newGI)}
            value={newGenderIdent}
          />
        </div>
      </div>
      <div>
        <CFormLabel className="label">Preferred Language</CFormLabel>
        <div className="select-box-holder">
          <CFormSelect
            className={'select-box full-width fit-height'}
            options={formatForSingleSelect(demographicCodes.languageCodes)}
            onChange={({ target: { value: newPL } }) => setNewPrefLang(newPL)}
            value={newPrefLang}
          />
        </div>
      </div>
      <div className={'buttons-row'}>
        <CButton onClick={() => setEditPatientDemo(false)} color={'secondary'}>
          Cancel
        </CButton>
        <CButton
          onClick={async () => {
            console.log({
              newRace,
              newEthnicity,
              newSexOrient,
              newGenderIdent,
              newPrefLang,
            })
            // todo is loading

            await dispatch(
              savePatientDetails({
                ethnicity: newEthnicity,
                genderIdentity: newGenderIdent,
                preferredLanguage: newPrefLang,
                race: newRace,
                sexualOrientation: newSexOrient,
              }),
            )
            setEditPatientDemo(false)
            // TODO and save
          }}
        >
          Save
        </CButton>
      </div>
    </div>
  )
}
